function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconVideo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-3.9%",
  y: "-4.2%",
  width: "107.9%",
  height: "107.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.250980392   0 0 0 0 0.305882353   0 0 0 0 0.349019608  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  fill: "#C5E3FF",
  points: "12 4.003 15 0.003 10 0.003 7 4.003"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  fill: "#C5E3FF",
  points: "18 0.003 15 4.003 22 4.003 22 0.003"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  fill: "#C5E3FF",
  points: "7 0.003 0 0.003 0 4.003 4 4.003"
});

var SvgIconFilm = function SvgIconFilm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-help-box",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-78.000000, -723.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-box-2",
    filter: "url(#filter-1)",
    transform: "translate(40.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 510.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(30.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clapboard-play",
    transform: "translate(8.000000, 8.000000)"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(1.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _ref6, _ref7, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M0,16.003 C0,17.108 0.895,18.003 2,18.003 L20,18.003 C21.104,18.003 22,17.108 22,16.003 L22,6.003 L0,6.003 L0,16.003 Z M9,8.003 L15,12.003 L9,16.003 L9,8.003 Z",
    id: "Shape",
    fill: "currentColor"
  }), _ref8)))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFilm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-film.cc9491fd.svg";
export { ForwardRef as ReactComponent };